<template>
  <div>
    <MainNav />
    <main class="container py-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 class="h3 mb-1">Alertes cash B2C</h1>
          <p class="text-muted mb-0">Visibles uniquement par le fondateur.</p>
        </div>
        <span class="badge bg-danger fs-6">{{ unreadCount }} non lue(s)</span>
      </div>

      <div v-if="loading" class="alert alert-secondary">Chargement…</div>
      <div v-else-if="forbidden" class="alert alert-danger">
        Cet espace est réservé au fondateur désigné.
      </div>
      <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
      <div v-else-if="alerts.length === 0" class="alert alert-success">
        Aucune alerte cash.
      </div>

      <div v-else class="list-group shadow-sm">
        <article
          v-for="alert in alerts"
          :key="alert.id"
          class="list-group-item list-group-item-action"
          :class="{ 'border-danger': !alert.read_at }"
        >
          <div class="d-flex w-100 justify-content-between gap-3">
            <div>
              <h2 class="h6 mb-1">
                {{ alert.kind === 'COLLECTOR_LIMIT' ? 'Seuil de 7 000 € dépassé' : 'Garde depuis au moins 10 jours' }}
              </h2>
              <p class="mb-1">
                Collecteur : <strong>{{ alert.collector.name }}</strong> —
                solde : <strong>{{ formatEuro(alert.balance) }}</strong>
              </p>
              <small class="text-muted">
                Transfert #{{ alert.transfer_id }} · {{ formatDate(alert.created_at) }}
              </small>
            </div>
            <button
              v-if="!alert.read_at"
              class="btn btn-sm btn-outline-secondary align-self-start"
              @click="markRead(alert)"
            >
              Marquer comme lue
            </button>
          </div>
        </article>
      </div>
      <div v-if="hasMore && !loading" class="text-center mt-3">
        <button class="btn btn-outline-secondary" :disabled="loadingMore" @click="loadMore">
          {{ loadingMore ? 'Chargement…' : 'Afficher les alertes précédentes' }}
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import MainNav from '../components/MainNav.vue'

export default {
  name: 'CashAlerts',
  components: { MainNav },
  data() {
    return {
      alerts: [],
      unreadCount: 0,
      loading: true,
      forbidden: false,
      error: '',
      hasMore: false,
      loadingMore: false,
    }
  },
  async mounted() {
    document.title = 'Alertes cash | Admin'
    await this.loadAlerts()
  },
  methods: {
    async loadAlerts() {
      this.loading = true
      this.error = ''
      try {
        const { data } = await axios.get('/api/v1/admin/cash-alerts/', {
          params: { offset: 0, limit: 100 },
        })
        this.alerts = data.results
        this.unreadCount = data.unread_count
        this.hasMore = Boolean(data.has_more)
      } catch (error) {
        this.forbidden = error.response?.status === 403
        if (!this.forbidden) this.error = "Impossible de charger les alertes cash."
      } finally {
        this.loading = false
      }
    },
    async loadMore() {
      this.loadingMore = true
      try {
        const { data } = await axios.get('/api/v1/admin/cash-alerts/', {
          params: { offset: this.alerts.length, limit: 100 },
        })
        this.alerts.push(...data.results)
        this.unreadCount = data.unread_count
        this.hasMore = Boolean(data.has_more)
      } catch (error) {
        this.error = "Impossible de charger l'historique des alertes cash."
      } finally {
        this.loadingMore = false
      }
    },
    async markRead(alert) {
      const { data } = await axios.post(`/api/v1/admin/cash-alerts/${alert.id}/read/`)
      alert.read_at = data.read_at
      this.unreadCount = Math.max(0, this.unreadCount - 1)
    },
    formatEuro(value) {
      return new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR' }).format(Number(value))
    },
    formatDate(value) {
      return new Intl.DateTimeFormat('fr-BE', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value))
    },
  },
}
</script>
